let user = {
  functions: {
    customer: 'Cliente',
    waiter: 'Garçon',
    deliveryman: 'Entregador',
    kitchen: 'Cozinha',
    cashier: 'Caixa',
    manager: 'Gerente',
    administrator: 'Administrador'
  }
}

export default user
